<template>
  <div v-wechat-title="titleTop">
    <div v-if="loading">正在微信授权登录中...</div>
    <div v-if="message">{{ message }}</div>
    <div v-if="!loading && list && list.length>1" class="selectRect">
      请选择一个关联的机构
      <div v-for="item in list" :key="item.orgId" class="selectLine" @click="onClick(item)">
        {{ item.name }}
        <van-tag v-if="item.agentSystem" type="danger">代理</van-tag>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Tag } from 'vant'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetSelfUrl } from '@/utils/request'
import store from '@/store'
import { getUrlKey } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Tag.name]: Tag
  },
  data() {
    return {
      titleTop: '专业人士登录',
      backurl: '/store/index',
      code: undefined,
      list: [],
      loading: true,
      message: ''
    }
  },

  created() {
    this.code = getUrlKey('code')
    console.log('ProLogin', this.code)
    if (!this.code) {
      this.gotoLogin()
      return
    } else {
      this.loginCallback(() => {
        if (!this.list || this.list.length <= 0) {
          this.message = '本功能仅对潜水业内专业人士开放，账号审核请添加管理员，微信：dive-boss'
          return
        }
        if (this.list.length === 1) {
          var url = GetSelfUrl() + 'pro/index?system=' + (this.list[0].agentSystem ? this.list[0].agentSystem : this.list[0].system)
          window.location.href = url
          return
        }
      })
    }
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    async gotoLogin() {
      var url = GetSelfUrl() + 'pro/login'
      console.log('跳转页面去登录:', url)
      // alert('跳转页面去登录:' + url)
      await store.dispatch('user/getWxLoginUrl', url).then(response => {
        console.log('跳转页面去登录', response)
        window.location.href = response
      })
    },
    loginCallback(callback) {
      request({
        url: '/user/wechatProSystemList',
        method: 'post',
        params: { code: this.code }
      }).then(Response => {
        this.loading = false
        if (!Response.success) {
          return
        }
        this.list = Response.data
        if (callback) {
          callback()
        }
      })
    },
    onClick(item) {
      var url = GetSelfUrl() + 'pro/index?system=' + (item.agentSystem ? item.agentSystem : item.system)
      window.location.href = url
    }
  }
}
</script>
<style scoped>
.selectRect{
padding: 1em;

}
.selectRect .selectLine{
  margin-top: 1em;
  padding: 1.5em;
  background-color: #fff;
  font-size: 1.1em;
  border-radius: 0.4em;
}
</style>
